import { isSSR } from '@helpers/ssr';
import { useEffect, useState } from 'react';

const useOneTrustCookieLevel = (): string[] => {
  const [level, setLevel] = useState<string[]>(() => {
    if (isSSR) {
      return [];
    }

    return parseCookieLevel(window.OnetrustActiveGroups);
  });

  useEffect(() => {
    setLevel(parseCookieLevel(window.OnetrustActiveGroups));
  }, [isSSR ? null : window.OnetrustActiveGroups]);

  return level;
};

function parseCookieLevel(level: string | undefined): string[] {
  if (!level) {
    return [];
  }

  const levels = level.split(',').filter((x) => x !== ',' && x !== '');

  return levels;
}

export default useOneTrustCookieLevel;
